var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonNotifikation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.772 4.493a8.512 8.512 0 0 0-11.468 6.24 16.181 16.181 0 0 1-7.141 10.08 1.141 1.141 0 0 0 .216 2.036l20.683 7.528a1.141 1.141 0 0 0 1.475-1.421 16.181 16.181 0 0 1 1.009-12.31 8.512 8.512 0 0 0-4.774-12.153z",
    "data-name": "Path 40693"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.115 2.956.215-.443a2.42 2.42 0 1 1 4.35 2.119l-.216.443",
    "data-name": "Path 40694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.772 27.858c-.014 2.455-.249 3.684-1.686 3.675s-2.592-2.008-2.575-4.463",
    "data-name": "Path 40698"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonNotifikation);
export default __webpack_public_path__ + "static/media/Ikon_Notifikation.8b77cb3cffb336d531d76141dd44388d.svg";
export { ForwardRef as ReactComponent };